import { Injectable, signal, computed } from '@angular/core';

/**
 * Holds the current application context (e.g. schoolCode) when viewing an application
 * as operations admin. Used by the school-code HTTP interceptor to add the header
 * to all GET/POST (and other) requests in manage-applications flow.
 */
@Injectable({ providedIn: 'root' })
export class ApplicationContextService {
  private readonly schoolCodeSignal = signal<string | null>(null);

  readonly schoolCode = this.schoolCodeSignal.asReadonly();
  readonly hasSchoolCode = computed(() => !!this.schoolCodeSignal()?.trim());

  setSchoolCode(code: string | null): void {
    this.schoolCodeSignal.set(code?.trim() || null);
  }

  setSchoolCodeFromApplicationResponse(response: unknown): string | null {
    const data = (response as { data?: { schoolCode?: unknown } } | null)?.data;
    const schoolCode =
      typeof data?.schoolCode === 'string' ? data.schoolCode.trim() : '';

    this.setSchoolCode(schoolCode);
    return this.getSchoolCode();
  }

  getSchoolCode(): string | null {
    return this.schoolCodeSignal();
  }

  clearSchoolCode(): void {
    this.schoolCodeSignal.set(null);
  }
}
